module.exports = __webpack_public_path__ + "img/XL_NAVETTES.f45edf96.svg";